import {createSinglePathSVG} from './TEMPLATE'

export const Wallet_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-1a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Zm15 4H4v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6Zm-4 2a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2h-1a1 1 0 0 1-1-1Z',
})
